
  // ============================================================
  // STICKY BOTTOM BAR: appears at 70% of page scroll
  // ============================================================
  (function() {
    var stickyBar = document.getElementById('lyphea-sticky-bar');
    if (!stickyBar) return;

    function relocateStickyBar() {
      if (stickyBar.parentNode !== document.body) {
        document.body.appendChild(stickyBar);
      }
    }

    if (document.body) {
      relocateStickyBar();
    } else {
      document.addEventListener('DOMContentLoaded', relocateStickyBar);
    }

    var ticking = false;

    // On desktop the Horizon theme scrolls inside .page-wrapper (html/body are overflow:hidden), on mobile the window scrolls.
    function getScroller() {
      var w = document.querySelector('.page-wrapper');
      if (w && w.scrollHeight > w.clientHeight + 50) {
        var oy = window.getComputedStyle(w).overflowY;
        if (oy === 'auto' || oy === 'scroll') return w;
      }
      return null;
    }

    function updateStickyBar() {
      var scroller = getScroller();
      var scrollPercent;
      if (scroller) {
        var maxS = scroller.scrollHeight - scroller.clientHeight;
        scrollPercent = maxS > 0 ? (scroller.scrollTop / maxS) * 100 : 0;
      } else {
        var doc = document.documentElement;
        var scrollHeight = Math.max(
          document.body.scrollHeight, doc.scrollHeight,
          document.body.offsetHeight, doc.offsetHeight,
          document.body.clientHeight, doc.clientHeight
        );
        var maxScroll = scrollHeight - window.innerHeight;
        scrollPercent = maxScroll > 0 ? (window.scrollY / maxScroll) * 100 : 0;
      }

      if (scrollPercent > 70) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyBar);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('touchmove', onScroll, { passive: true });

    setTimeout(function() {
      relocateStickyBar();
      updateStickyBar();
    }, 100);

    window.addEventListener('load', function() {
      relocateStickyBar();
      updateStickyBar();
    });
  })();
